import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.707 7.707a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 0 0 0 1.414l10 10a1 1 0 0 0 1.414-1.414L7.414 17z"
    />
    <path
      fill="currentColor"
      d="M26.707 7.707a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 0 0 0 1.414l10 10a1 1 0 0 0 1.414-1.414L17.414 17z"
    />
  </svg>
);
const SvgIconCaretDoubleRight = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCaretDoubleRight);
export default Memo;
